import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Ready translated locale messages
const messages = {
    en: {
        message: {
            title: 'WTO',
            save: 'Save',
            delete: 'Delete',
            edit: 'Edit',
            create: 'Create',
            comment: 'Comment',
            back: 'Back',
            loading: 'Please hold on',
            logout: 'Logout',
            release: 'Release',
            openByMe: 'Task',
            releaseFlow: 'Release flow',
            productGroup: 'Product group',
            productType: 'Product type',
            user: 'User',
            department: 'Department',
            product: 'Product',
            open: 'Open',
            locked: 'Locked',
            lock: 'Lock',
            approved: 'Approved',
            newRevision: 'New Revision',
            reportIssue: 'Report Issue',
        },
        release: {
            release: 'Release',
            title: 'Title',
            revision: 'Revision',
            verfication_date: 'Verfication date',
            actual_revision: 'Actual revision',
            new_image_revision: 'New image revision',
            upload_image: 'Click here to upload image',
            comment: 'Comment',
            product_information: 'Product information',
            release_flow: 'Release flow',
            send_comment: 'Send comment',
            product: 'Product',
            releaseFlow: 'Release Flow',
            protocol: 'Protocol',
            status: 'Status',
            search: 'Search',
        },
        releaseFlow: {
            releaseFlow: 'Product flow',
            title: 'Title',
            department: 'Department',
            step: 'Step for',
        },
        productGroup: {
            productGroup: 'Product group',
            title: 'Title',
        },
        productType: {
            productType: 'Product type',
            title: 'Title',
        },
        product: {
            product: 'Product',
            number: 'Number',
            customer_number: 'Customer number',
            description: 'Description',
            extra_description: 'Extra description',
            title: 'Title',
            extra_dimension: 'Extra Dimension',
            material: 'Material',
            width: 'Width',
            height: 'Height',
            productType: 'Product type',
            productGroup: 'Product group',
            connected: 'related product',
            search: 'Search',
        },
        department: {
            department: 'Department',
            user: 'User',
            title: 'Title',
        },
        user: {
            user: 'User',
            name: 'Name',
            firstname: 'Firstname',
            surname: 'Surname',
            email: 'E-Mail',
            password: 'Password',
            department: 'Department',
            roles: 'Role',
        },
    },
    de: {
        message: {
            title: 'WTO',
            save: 'Speichern',
            delete: 'Löschen',
            loading: 'Bitte warten',
            comment: 'Kommentieren',
            logout: 'Abmelden',
            release: 'Freigaben',
            openByMe: 'Aufgaben',
            releaseFlow: 'Freigabekette',
            productGroup: 'Produktgruppe',
            productType: 'Produkttyp',
            user: 'Benutzer',
            department: 'Abteilung',
            product: 'Produkte',
            open: 'Offen',
            locked: 'Gesperrt',
            lock: 'Sperren',
            approved: 'Freigegeben',
            newRevision: 'Neue Revision',
            reportIssue: 'Fehler melden',
        },
        release: {
            release: 'Freigabe',
            title: 'Titel',
            revision: 'Revision',
            verfication_date: 'Verifikationsdatum',
            actual_revision: 'Aktuelle Revision',
            new_image_revision: 'Neue Revision',
            upload_image: 'Klicke hier um ein Bild hochzuladen',
            comment: 'Kommentar absenden',
            product_information: 'Produkt information',
            release_flow: 'Freigabekette',
            send_comment: 'Kommentar absenden',
            product: 'Produkt',
            releaseFlow: 'Freigabekette',
            protocol: 'Protokoll',
            status: 'Status',
            search: 'Suche',
        },
        releaseFlow: {
            releaseFlow: 'Freigabekette',
            title: 'Titel',
            department: 'Abteilung',
            step: 'Schritt für',
        },
        productGroup: {
            productGroup: 'Produktgruppe',
            title: 'Titel',
        },
        productType: {
            productType: 'Produkttyp',
            title: 'Titel',
        },
        product: {
            product: 'Produkt',
            number: 'Nummer',
            customer_number: 'Kundennummer',
            description: 'Beschreibung',
            extra_description: 'Extra Beschreibung',
            title: 'Titel',
            extra_dimension: 'Extra Dimension',
            material: 'Material',
            width: 'Breite',
            height: 'Höhe',
            productType: 'Produkt Typ',
            productGroup: 'Produkt Gruppe',
            connected: 'Verknüpfung',
            search: 'Suche',
        },
        department: {
            department: 'Abteilung',
            user: 'User',
            title: 'Titel',
        },
        user: {
            user: 'User',
            name: 'Name',
            firstname: 'Vorname',
            surname: 'Nachname',
            email: 'E-Mail',
            password: 'Passwort',
            department: 'Abteilung',
            roles: 'Rolle',
        },
    },
};

// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: 'de', // set locale
    messages, // set locale messages
});

